import axios, { AxiosInstance } from 'axios';
import { convertSnakeToCamel } from '@/utils';

const baseDomain = import.meta.env.VITE_API_BASE_DOMAIN;
const baseURL = `${baseDomain}/wp/index.php?rest_route=/wp/v2`;

export const wpAxiosClientController = new AbortController();
const signal = wpAxiosClientController.signal;

/**
 * WordPress 接続用 Axios インスタンス
 */
const repository: AxiosInstance = axios.create({
  baseURL,
  signal,
});

const __DEBUG__ = import.meta.env.MODE !== 'prod';

repository.interceptors.response.use(
  (response) => {
    if (__DEBUG__) {
      console.debug(
        `[${response.config.method?.toUpperCase()}] ${response.config.url} => ${response.status}`,
        convertSnakeToCamel(response.data)
      );
    }

    if (response.data) {
      convertSnakeToCamel(response.data);
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default repository;
